import * as React from "react";
import { singleton } from "logic/singleton";
const UserDateTimeContext = React.createContext(void 0);
export default singleton("contexts.UserDateTimeContext", () => UserDateTimeContext);
